var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ir-generic-component-regular",staticStyle:{"padding-bottom":"25px","border":"0px solid"}},[_c('div',{staticStyle:{"max-width":"1000px"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getPageContent)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }